<form [formGroup]="form">
  <div class="form-row" *ngIf="center?.centroId">
    <label for="txtCode">{{ "WEB_RESULTS.CENTERS.ID" | translate }}</label>
    <input
      type="text"
      id="txtCode"
      class="w-full"
      pInputText
      formControlName="centroId"
    />
  </div>

  <div class="form-row">
    <label for="txtDescription">{{
      "WEB_RESULTS.CENTERS.NAME" | translate
    }}</label>
    <input
      type="text"
      id="txtDescription"
      class="w-full"
      pInputText
      formControlName="centroName"
      maxlength="100"
    />
  </div>

  <p-card [header]="'WEB_RESULTS.CENTERS.ASSIGN_SERVICES' | translate">
    <div class="form-row">
      <label for="hospital">{{
        "WEB_RESULTS.CENTERS.HOSPITAL" | translate
      }}</label>
      <p-dropdown
        [style]="{ width: '100%' }"
        id="hospital"
        [options]="hospitals"
        (onChange)="onHospitalChange($event)"
        placeholder="{{ 'WEB_RESULTS.CENTERS.HOSPITAL_PLACEHOLDER' | translate }}"
        dataKey="anstaltNr"
        optionLabel="anstName"
        [showClear]="true"
        formControlName="selectedHospital"
        [filter]="true"
        filterBy="anstName"
      ></p-dropdown>
    </div>
    <afoone-select-shopping-cart
      formControlName="assignedServices"
      [availableItems]="availableServices"
      leftTitle="{{ 'WEB_RESULTS.CENTERS.AVAILABLE_SERVICES' | translate }}"
      rightTitle="{{ 'WEB_RESULTS.CENTERS.SELECTED_SERVICES' | translate }}"
    >
    </afoone-select-shopping-cart>
  </p-card>
</form>

<div class="p-dialog-footer center-dialog-footer">
  <p-button
    label="Guardar cambios"
    (click)="saveChanges()"
    [loading]="saving"
  ></p-button>
</div>
